import { Injectable, TemplateRef, signal, WritableSignal } from '@angular/core'

export interface ModalParams {
	title: ModalContentV2['title']
	body: ModalContentV2['body']
	translate?: boolean
}

// Defines the structure of modal's "named slots" for content projection
interface ModalContentV2 {
	body: string | TemplateRef<unknown>   	// Required
  title?: string | TemplateRef<unknown>		// Can be text OR a template
	translate?: boolean
}

interface ModalStateV2 {
  isOpen: boolean
  content: ModalContentV2
	translate: boolean
  context?: unknown // Data to pass to the template
	config: ModalConfigV2
}

interface ModalConfigV2 {
	closable: boolean
}

@Injectable({ providedIn: 'root' })
export class ModalServiceV2 {
	private defaultModalConfig: ModalConfigV2 = {
		closable: true
	}

	// Current state of the modal
	public modalState: WritableSignal<ModalStateV2> = signal({
		isOpen: false,
		content: {
			title: '',
			body: ''
		},
		translate: false,
		context: null,
		config: this.defaultModalConfig
	})

	/**
   * Opens the global modal with specific content.
   * @param content Modal content for title, body and footer that should be rendered
   * @param context Optional data to pass to the template
   * @param config 	Optional modal config
   */
	open(params: ModalParams, context?: unknown, config?: ModalConfigV2) {
		this.modalState.set({
			isOpen: true,
			content: {
				title: params.title,
				body: params.body
			},
			translate: params?.translate || false,
			context: context,
			config: {
				...this.defaultModalConfig,
				...(config && config)
			}
		})
	}

	close() {
		this.modalState.set({
			isOpen: false,
			content: {
				title: '',
				body: ''
			},
			context: null,
			translate: false,
			config: this.defaultModalConfig
		})
	}
}
